// extracted by mini-css-extract-plugin
module.exports = {"base":"Links_base__2BG2w"};